import type { ScriptLine } from "../../coldcompute";

// Caption lines are SCENE-LOCAL (fromSec resets to 0 inside each scene's <Sequence>).
// Every claim grounded in EAKC-MVP:
//   src/lib/skills/types.ts (SKILL_KINDS — 12 kinds, mig 204)
//   src/lib/skills/applier/registry.ts + handlers/no-op.ts (pre-fix: 1 real, 11 stubs)
//   src/lib/skills/applier/index.ts (engine flips state='active' regardless)
//   docs/2026-05-28-skills-lifecycle-p3a-complete.md (P3.A fix, migs 209–218, 216/216 jest)

export const HOOK: ScriptLine[] = [
  { scene: "hook", fromSec: 0.3, holdSec: 4.5, caption: "I shipped a self-learning AI with 12 types of skill. The dashboard said they were all live. Eleven of them did nothing." },
];

export const PROBLEM: ScriptLine[] = [
  { scene: "problem", fromSec: 0.4, holdSec: 5.5, caption: "The idea: the agent learns from its runs and writes itself new skills — persona rules, glossaries, tool preferences, twelve kinds in all." },
  { scene: "problem", fromSec: 6.2, holdSec: 6, caption: "I defined all twelve in one array: SKILL_KINDS, in src/lib/skills/types.ts." },
  { scene: "problem", fromSec: 12.5, holdSec: 5.5, caption: "But an applier needs a handler PER kind — the code that actually changes something. I'd written exactly one." },
];

export const REVEAL: ScriptLine[] = [
  { scene: "reveal", fromSec: 0.4, holdSec: 6, caption: "The other eleven fell through to a no-op stub: it logged a line, returned null, and mutated nothing." },
  { scene: "reveal", fromSec: 6.6, holdSec: 7, caption: "And the engine flips every skill to state 'active' regardless. So the UI showed eleven active skills — that were silently inert." },
];

export const CATALOGUE: ScriptLine[] = [
  { scene: "catalogue", fromSec: 0.4, holdSec: 5.5, caption: "Only persona-rule actually wrote anything — into the agent's persona prompt, wrapped in markers so it could be undone." },
  { scene: "catalogue", fromSec: 6.2, holdSec: 6, caption: "glossary, tool-preference, verify-rule, plan-template, cost-policy… all defined, all 'active', all doing nothing." },
];

export const FIX: ScriptLine[] = [
  { scene: "fix", fromSec: 0.4, holdSec: 5.5, caption: "The fix, on 2026-05-28: build the other eleven handlers for real, each landing in its own table." },
  { scene: "fix", fromSec: 6.2, holdSec: 6, caption: "Ten new tables — tool preferences, glossary, verify rules, exemplars, plan templates — migrations 209 through 218." },
  { scene: "fix", fromSec: 12.5, holdSec: 6.5, caption: "Two gated kinds — recipient-change and tool-allowlist-write — apply only after I approve them. No silent self-edits." },
];

export const CODE: ScriptLine[] = [
  { scene: "code", fromSec: 0.5, holdSec: 6, caption: "The proof is the registry: every kind now maps to a real handler." },
  { scene: "code", fromSec: 7, holdSec: 7, caption: "The for-loop that backfilled no-op stubs now finds nothing left to fill — noOpHandler covers zero kinds." },
  { scene: "code", fromSec: 14.5, holdSec: 5, caption: "Each handler stores a prior value, so the existing Undo button works without any schema change." },
];

export const PAYOFF: ScriptLine[] = [
  { scene: "payoff", fromSec: 0.4, holdSec: 5.5, caption: "1 of 12 handlers actually ran. Now it's 12 of 12 — every learned skill has a real runtime effect." },
  { scene: "payoff", fromSec: 6.2, holdSec: 6, caption: "216 tests green. The no-op stub still exists in the repo — but it's reachable by nothing." },
];

export const OUTRO: ScriptLine[] = [
  { scene: "outro", fromSec: 0.4, holdSec: 5, caption: "The lesson: 'state = active' is not the same as 'it did something'. A green dashboard can lie." },
  { scene: "outro", fromSec: 5.6, holdSec: 4, caption: "Next: the last 10% of building this solo — why it's trust, not code." },
];

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
